import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { pipViewDate } from "../../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/form/NoRecord";
import StatusCol from "../../../components/table/StatusCol";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import TableHeader from "../../../components/table/tableHeader";
import ReactPagination from "../../../components/table/ReactPagination";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import {
  coachDeleteContent,
  fetchContent,
} from "../../../redux/features/coach/actions/coachAction";
import ResourceFilter from "../../../components/pages/coach/resources/ResourceFilter";
import ConetentDetails from "../../../components/pages/find-a-job/modals/ConetentDetails";
import ConfirmationModal from "../../../components/Modals/common/webinar/ConfirmationModal";
import CreateContentModal from "../../../components/Modals/common/resource content/CreateContentModal";
import EditContentModal from "../../../components/Modals/common/resource content/EditContentModal";

const CoachResources = () => {
  const dispatch = useDispatch();
  const [isCreateContent, setIsCreateContent] = useState(false);
  const [isEditContent, setIsEditContent] = useState(false);
  const { isLoading2, contentList, resourceHeader } = useSelector(
    (state) => state?.coach?.coach
  );
  const [id, setId] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [activeData, setActiveData] = useState(null);
  const tabs = [
    {
      lable: "All",
      value: "all",
    },
    {
      lable: "eBook",
      value: "eBook",
    },
    {
      lable: "Guide",
      value: "Guide",
    },
    {
      lable: "Workbook",
      value: "Workbook",
    },
    {
      lable: "Media",
      value: "Media",
    },
    {
      lable: "Presentation",
      value: "Presentation",
    },
    {
      lable: "Integration",
      value: "Integration",
    },
    {
      lable: "Recording",
      value: "Recording",
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);

  const paginatedList =
    contentList[activeTab]?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  useEffect(() => {
    dispatch(fetchContent());
  }, [activeTab]);

  const handleDeleteContent = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchContent());
      }
    };
    dispatch(coachDeleteContent({ payload: id, callback }));
  };

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <CoachMenuLayout>
      <div className="ct_px_40 mt-4">
        <div className="row">
          <ResourceFilter />
          <div className=" col-lg-9 col-md-9 mb-4 mb-md-0">
            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
              <div>
                <h4 className="mb-0 ct_fs_20  mb-0">Resources</h4>
                <p className="mb-0 ct_text_clr_757886">
                  View, approve, and moderate resources across the platform
                </p>
              </div>
              <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                <div className="position-relative ct_w_100_575">
                  <input
                    type="text"
                    className="form-control ct_input ct_h_35 ps-5"
                    placeholder="Search by Title"
                  />
                  <i className="fa-solid fa-search ct_input_icon_left"></i>
                </div>
                <button
                  className="ct_yellow_btn ct_h_35 ct_w_100_575"
                  onClick={() => setIsCreateContent(true)}
                >
                  <i className="fa-solid fa-plus ct_fs_14 me-1"></i> Upload
                  Content
                </button>
              </div>
            </div>
            <ul className="ct_table_filter">
              {tabs?.map((item, ind) => (
                <li
                  style={{ cursor: "pointer" }}
                  className={item?.value == activeTab ? "active" : ""}
                  onClick={() => setActiveTab(item?.value)}
                >
                  {item?.lable}

                  {contentList[item?.value]?.length > 0 &&
                    ` (${contentList[item?.value]?.length})`}
                </li>
              ))}
            </ul>
            <div className="table-responsive ct_custom_table pt-2">
              <table className="table">
                <TableHeader data={resourceHeader} />
                {paginatedList?.length > 0 && (
                  <tbody>
                    {paginatedList?.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item?.title || "#N/A"}</td>
                        <td>{item?.content_type || "#N/A"}</td>
                        <StatusCol
                          type="resourceContent"
                          status={item?.status}
                        />
                        {/* <td>
                          
                          <span className="ct_publish_badge">Published</span>
                        </td> */}
                        <td>{pipViewDate(item?.created_at) || ""}</td>
                        <td>
                          {item?.visibility || "#N/A"}
                          {/* <select className="form-control ct_input border-0">
                            <option value="">Public</option>
                          </select> */}
                        </td>
                        <td>
                          <div className="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li
                                onClick={() => {
                                  setActiveData(item);
                                  setIsModal(true);
                                }}
                              >
                                <a className="dropdown-item" href="#">
                                  View Details
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item ct_darksky_blue_text"
                                  onClick={() => {
                                    setActiveData(item);
                                    setIsEditContent(true);
                                  }}
                                >
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  onClick={() => setId(item?.content_id)}
                                  data-bs-target="#ct_remove_content"
                                  data-bs-toggle="modal"
                                >
                                  Remove{" "}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>

              {paginatedList?.length <= 0 && <NoRecord />}
            </div>
            {paginatedList?.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-4 ">
                <div>
                  <PaginationDropdown
                    onChange={(val) => {
                      setListPerPages(val);
                      setCurrentPage(0);
                    }}
                  />
                </div>
                <div>
                  <ReactPagination
                    pageCount={Math.ceil(
                      contentList[activeTab]?.length / listPerPages
                    )}
                    onPageChange={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ConetentDetails
        isModal={isModal}
        setIsModal={setIsModal}
        data={activeData}
      />

      <ConfirmationModal
        id="ct_remove_content"
        title="Delete Content"
        onConfirm={handleDeleteContent}
      />

      {isCreateContent && (
        <CreateContentModal onClose={() => setIsCreateContent(false)} />
      )}

      {isEditContent && (
        <EditContentModal
          onClose={() => setIsEditContent(false)}
          data={activeData}
        />
      )}
    </CoachMenuLayout>
  );
};

export default CoachResources;
